
import React, { useContext, useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import { InputGroup, Form } from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination';
import { Button } from '@/shared/components/Button';
import toast from 'react-hot-toast';
import { FaArrowUpShortWide, FaArrowDownWideShort } from 'react-icons/fa6';
import { AuthContext } from '../../../../../../context/AuthContext';
import { GlobalContext } from '../../../../../../context/GlobalContext';
import { SideBarRefreshContext } from '../../../../../../context/SideBarRefreshContext';

const DataReactTable = () => {
  const [RejectData, setRejectData] = useState([]);
  const { apiGlobal } = useContext(GlobalContext);
  const { agentId, countryId } = useContext(AuthContext);
  const [searchStartDate, setSearchStartDate] = useState('');
  const [searchEndDate, setSearchEndDate] = useState('');
  const [refresh, setRefresh] = useState(false);
  const [filteredRejectData, setFilteredRejectData] = useState([]);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  const fetchRejectData = async () => {
    const formData = new FormData();
    formData.append('agent_id', agentId);
    formData.append('country_id', countryId);
    try {
      const response = await fetch(`${apiGlobal}/agent/account_reject_list.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data.status && data.message === 'Success') {
        setRejectData(data.data);
        setFilteredRejectData(data.data); // Initialize with full data
      } else {
        setRejectData([]);
        setFilteredRejectData([]);
        console.error('No data found');
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchRejectData();
  }, [refresh, sideBarRefresh?.agentrejectRefresh]);

  // Filter Data Based on Date Range
  useEffect(() => {
    let filteredData = RejectData;

    if (searchStartDate) {
      filteredData = filteredData.filter((trip) => {
        const tripPaymentDate = new Date(trip.payment_date); // ✅ FIXED
        return tripPaymentDate.getTime() === new Date(searchStartDate).getTime();
      });
    }

    // if (searchEndDate) {
    //   filteredData = filteredData.filter(trip => new Date(trip?.payment_date) <= new Date(searchEndDate));
    // }

    setFilteredRejectData(filteredData);
    setCurrentPage(1); // Reset to first page when filters are applied
  }, [searchStartDate, RejectData]); // Removed filteredRejectData from dependencies

  // Pagination Logic - Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredRejectData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredRejectData.length / itemsPerPage);

   const [sortOrder, setSortOrder] = useState('asc');
    const [sortColumn, setSortColumn] = useState('payment_date'); // This will track the column being sorted
     
    const handleSort = (column) => {
      const newSortOrder = sortColumn === column && sortOrder === 'asc' ? 'desc' : 'asc';
    
      const sortedData = [...filteredRejectData].sort((a, b) => {
        if (column === 'payment_date') {
          return newSortOrder === 'asc'
            ? new Date(a.payment_date) - new Date(b.payment_date)
            : new Date(b.payment_date) - new Date(a.payment_date);
            // eslint-disable-next-line
        } else if (column === 'balance') {
          return newSortOrder === 'asc'
            ? parseFloat(a.balance) - parseFloat(b.balance)
            : parseFloat(b.balance) - parseFloat(a.balance);
        } else if (column === 'status') {
          return newSortOrder === 'asc' ? a.status.localeCompare(b.status) : b.status.localeCompare(a.status);
        }
        return 0;
      });
    
      setFilteredRejectData(sortedData); // Ensure UI updates correctly
      setSortOrder(newSortOrder);
      setSortColumn(column);
    };

  return (
    <div>
      {/* Search Filters */}
      <div
        className="mb-4"
        style={{
          padding: '15px',
          borderRadius: '8px',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          gap: '10px',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <InputGroup style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            value={searchStartDate}
            onChange={e => setSearchStartDate(e.target.value)}
            style={{ borderRadius: '25px', padding: '8px', border: '1px solid #ddd' }}
          />
        </InputGroup>

        {/* <InputGroup style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            value={searchEndDate}
            onChange={e => setSearchEndDate(e.target.value)}
            style={{ borderRadius: '25px', padding: '8px', border: '1px solid #ddd' }}
          />
        </InputGroup> */}

        <Button
          variant="outline-danger"
          className="mt-3"
          style={{ borderRadius: '25px', padding: '8px 16px', marginLeft: '10px' }}
          onClick={() => {
            setSearchStartDate('');
            setSearchEndDate('');
            setFilteredRejectData(RejectData); // Reset filter when clearing
          }}
        >
          Clear Filters
        </Button>
        <Button
          variant="outline-danger"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '2px',
            alignSelf: 'center',
          }}
          className="mt-3"
          onClick={() => {
            setRefresh(prev => !prev);
            toast.success('Data Refreshed Successfully');
          }}
        >
          Refresh
        </Button>
      </div>

      {/* Table */}
      <Table
        responsive
        style={{
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <thead className="bg-danger" style={{ color: 'white', textAlign: 'center' }}>
          <tr>
            <th>#</th>
            <th onClick={() => handleSort('payment_date')} style={{ cursor: 'pointer' }}>
              Payment Date {sortColumn === 'payment_date' 
              && (sortOrder === 'asc' ? <FaArrowUpShortWide /> : <FaArrowDownWideShort />)}
            </th>
            <th onClick={() => handleSort('balance')} style={{ cursor: 'pointer' }}>
              Booking Amount {sortColumn === 'balance' 
              && (sortOrder === 'asc' ? <FaArrowUpShortWide /> : <FaArrowDownWideShort />)}
            </th>
            <th>Reject Remark</th>
            {/* <th>Action</th> */}
          </tr>
        </thead>
        <tbody>
          {currentItems.length === 0 ? (
            <tr>
              <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                <h3>No Reject Payment Data Available</h3>
              </td>
            </tr>
          ) : (
            currentItems.map((booking, index) => (
              <tr 
                key={booking.id} 
                style={{ 
                  backgroundColor: index % 2 === 0 ? '#ffffff' : '#f2f2f2', 
                textAlign: 'center', 
                }}
              >
                <td>{indexOfFirstItem + index + 1}</td>
                <td>{formatDate(booking.payment_date)}</td>
                <td>{booking.balance}</td>
                <td><span className="text-danger">{booking.remark}</span></td>
                {/* <td><Button type="button" variant="danger"><FaTrash /></Button></td> */}
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {/* Pagination Controls */}
      {/* {totalPages > 1 && ( */}
      <div style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Pagination>
          <Pagination.Prev
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {Array.from({ length: totalPages }, (_, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => setCurrentPage(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
            ))}
          <Pagination.Next
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>
      {/* )} */}
    </div>
  );
};

export default DataReactTable;
